import { render, staticRenderFns } from "./separateweight.vue?vue&type=template&id=c96cc014&scoped=true&"
import script from "./separateweight.vue?vue&type=script&lang=js&"
export * from "./separateweight.vue?vue&type=script&lang=js&"
import style0 from "./separateweight.vue?vue&type=style&index=0&id=c96cc014&scoped=true&lang=css&"
import style1 from "./separateweight.vue?vue&type=style&index=1&lang=css&"
import style2 from "./separateweight.vue?vue&type=style&index=2&id=c96cc014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96cc014",
  null
  
)

export default component.exports